import useSWR from "swr";
import {
  NotificationListResponse,
  NotificationParamsType,
  NotificationUnreadCountResponse,
} from "constants/types/notification";

// Tự build query thay vì dùng serialize vì serialize bỏ qua giá trị false
function buildNotificationQuery(params?: NotificationParamsType): string {
  if (!params) return "";
  const parts: string[] = [];
  if (params.page !== undefined) parts.push(`page=${params.page}`);
  if (params.limit !== undefined) parts.push(`limit=${params.limit}`);
  if (params.search) parts.push(`search=${encodeURIComponent(params.search)}`);
  if (params.isRead !== undefined) parts.push(`isRead=${params.isRead}`);
  return parts.join("&");
}

export const getNotificationListKey = (
  params?: NotificationParamsType,
  enabled = true,
): string | null => {
  if (!enabled) return null;
  const qs = buildNotificationQuery(params);
  return qs ? `/notification?${qs}` : "/notification";
};

export const UNREAD_NOTIFICATION_COUNT_KEY = "/notification/unread-count";

export const useNotifications = (
  params?: NotificationParamsType,
  enabled = true,
) => {
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  }: {
    data: NotificationListResponse | undefined;
    error: any;
    isLoading: boolean;
    isValidating: boolean;
    mutate: any;
  } = useSWR(getNotificationListKey(params, enabled), {
    refreshInterval: 0,
    revalidateOnFocus: false,
    keepPreviousData: true,
  });

  return {
    notifications: data?.data,
    pagination: data?.meta,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export const useNotificationUnreadCount = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: NotificationUnreadCountResponse | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(UNREAD_NOTIFICATION_COUNT_KEY, {
    refreshInterval: 30000,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  });

  return {
    count: data?.data,
    error,
    isLoading,
    mutate,
  };
};
